import type { SocialPlatform, PersonalityQuestion } from './types';

import fbIcon from '@/assets/images/svg/facebook.svg';
import instaIcon from '@/assets/images/svg/instagram.svg';
import twitterIcon from '@/assets/images/svg/twitter.svg';
import youtubeIcon from '@/assets/images/svg/youtube.svg';
import linkedinIcon from '@/assets/images/svg/linkedin.svg';

export const SOCIAL_PLATFORMS: SocialPlatform[] = [
  { id: 'facebook', name: 'Facebook', icon: fbIcon, isConnected: false },
  { id: 'instagram', name: 'Instagram', icon: instaIcon, isConnected: false },
  { id: 'twitter', name: 'X (Former Twitter)', icon: twitterIcon, isConnected: false },
  { id: 'youtube', name: 'Youtube', icon: youtubeIcon, isConnected: false },
  { id: 'linkedin', name: 'Linkedin', icon: linkedinIcon, isConnected: false },
];

export const PERSONALITY_QUESTIONS: PersonalityQuestion[] = [
  {
    id: 'q1',
    text: 'When talking to a patient or friend...',
    disclaimer:
      'There are no right answers to these questions, so base your response on how you are today, not how you think you should be or would like to be in the future.',
    options: [
      { id: 'opt1', label: 'I maintain eye contact the whole time.', value: 'eye_contact' },
      {
        id: 'opt2',
        label: 'I alternate between looking at the person and looking down.',
        value: 'alternate',
      },
      {
        id: 'opt3',
        label: 'I look around the room a good deal of the time.',
        value: 'look_around',
      },
      {
        id: 'opt4',
        label: 'I try to maintain eye contact but look away from time to time.',
        value: 'try_maintain',
      },
    ],
  },
  // Add more questions here as needed
  {
    id: 'q2',
    text: 'How do you handle conflict?',
    options: [
      { id: 'opt1', label: 'I address it immediately.', value: 'immediate' },
      { id: 'opt2', label: 'I avoid it if possible.', value: 'avoid' },
    ],
  },
];

// --- Personality Configuration Options ---
export const CONFIG_TOPICS = [
  'Mental Toughness',
  'Technical Skills',
  'Team Leadership',
  'Career Guidance',
];

export const CONFIG_APPROACH = [
  'Share personal stories',
  'Give tactical advice',
  'Ask questions',
  'Provide encouragement',
];

export const CONFIG_INTERACTION = [
  'Talking to a mentor',
  'Chatting with a friend',
  'Learning from a coach',
  'Feeling inspired',
];

export const CONFIG_HOBBIES = [
  'Sports',
  'Music',
  'Reading',
  'Gaming',
  'Travel',
  'Cooking',
  'Art & Design',
  'Technology',
];
